import * as React from 'react';
import styled from 'styled-components';
import Title from '../title/Title';

// ############################ Styles ###########################
// tslint:disable:variable-name
const SCheckoutContainer = styled.div(({ theme }) => {
  return `
  display: flex;
  flex-direction: column;
  `;
});
const STableBox = styled.div(({ theme }) => {
  return `
  display: flex;
  flex-direction: column;
  `;
});

const STableRow = styled.div<{ isBold: boolean }>(
  ({ theme, isBold }) => `
  max-width: 350px;
  display: flex;
  font-size: ${theme.font.size.smallMedium3};
  font-weight: ${theme.font.weight.bold};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  padding: 10px;
  color: ${isBold ? theme.colors.primaryDark2 : theme.colors.grayLight2};
  border-bottom: 2px solid ${theme.colors.grayLight2};
  
  &:last-child {
    border-bottom: none;
  }
  `
);

const STableTitle = styled.div(({ theme }) => {
  return `
  min-width: ${theme.spacing.smallerGargantuan}px;
  margin-right: ${theme.spacing.larger2}px;
  `;
});

const STableValue = styled(STableTitle)<{ isBold: boolean }>(
  ({ theme, isBold }) => `
  font-weight: ${isBold ? theme.font.weight.bold : theme.font.weight.light};
  `
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface ICheckoutDetails {
  [key: string]: string;
  contractNumber: string;
  roInvoice: string;
  date: string;
  customer: string;
  amount: string;
}

export interface ICheckoutProps {
  title: string;
  children: ICheckoutDetails;
  titleList: Map<string, string>;
  isBold?: string;
  dataAt: string;
}

export default ({ children, title, titleList, isBold = '', dataAt }: ICheckoutProps) => {
  return (
    <SCheckoutContainer data-at={dataAt}>
      <Title style={{ paddingLeft: '10px' }} dataAt={'12'}>
        {title}
      </Title>
      <STableBox>
        {Object.keys(children).map((key, index) => (
          <STableRow key={index} isBold={isBold === key}>
            <STableTitle>{titleList.get(key)}</STableTitle>
            <STableValue isBold={isBold === key}>{children[key]}</STableValue>
          </STableRow>
        ))}
      </STableBox>
    </SCheckoutContainer>
  );
};
